<template>
  <div v-if="isLoading" class="flex items-center justify-center">
    <Loader color="#64748B" width="50px" height="50px" />
  </div>
  <template v-else>
    <button v-if="(lastPath === '/block') || (lastPath === '/search-result')"
      class="bg-white uppercase border-2 border-red text-blue-dark px-7 py-0.5 md:m-0 mb-10" style="border-radius: 3px"
      @click="goBack">
      Back
    </button>
    <div v-if="chainDetails && Object.keys(chainDetails).length > 0" class="mb-[50px]">
      <div class="text-left mt-14">
        <div class="flex items-start justify-start flex-wrap gap-[88px]">
          <div class="flex flex-col justify-start">
            <Paragraph class="font-inter-regular text-[#3B82F6] text-[25px] leading-[30px]" text="Chain number" />
            <Paragraph class="font-inter-regular text-[#3B82F6] text-[25px] leading-[65px] break-all w-full text-left"
              :text="`#${chainDetails.number}`" />
          </div>
           <div class="flex flex-col justify-start">
            <Paragraph class="font-inter-regular text-[#2A4067] text-[25px] leading-[29px]" text="Chain Name" />
            <Paragraph class="font-inter-regular text-[#2A4067] text-[25px] leading-[65px] break-all w-full text-left"
              :text="chainDetails.chainName" />
          </div>
        </div>
      </div>
      <div class="mt-[66px]">
        <Paragraph class="font-inter-regular text-[#2A4067] text-[24px] leading-[30px] mb-[10px]" text="Overview" />
        <div class="max-w-max flex gap-[93px] bg-white rounded-[12px] px-[22px] py-[5px]">
          <div class="flex-grow max-w-[664px]">
            <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px] min-w-[140px]"
                text="Total Accounts" />
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px]"
                :text="`${chainDetails.totalAccounts ? chainDetails.totalAccounts : ''}`" />
            </div>
            <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px] min-w-[140px]"
                text="Total Blocks" />
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px]"
                :text="`${chainDetails.totalBlocks ? chainDetails.totalBlocks : ''}`" />
            </div>
            <div class="flex gap-[105px] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px] min-w-[140px]"
                text="Total Transactions" />
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px]"
                :text="`${chainDetails.totalTransactions ? chainDetails.totalTransactions : ''}`" />
            </div>
            <!-- <div class="flex gap-[105px] border-b border-[#2699FB] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px] min-w-[91px]"
                text="Verification Status" />
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px]"
                :text="`${chainDetails.verificationStatus ? chainDetails.verificationStatus : ''}`" />
            </div> -->
            <!-- <div class="flex gap-[105px] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px] min-w-[91px]"
                text="ALL Merkle Root" />
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px]"
                :text="`${getTxCreationDateUtc(chainDetails)} UTC`" />
            </div>
            <div class="flex gap-[105px] py-[23px]">
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px] min-w-[91px]"
                text="VLL Merkle Root" />
              <Paragraph class="font-jost-regular text-[#2A4067] text-[16px] leading-[21px]"
                :text="`${getTxCreationDateUtc(chainDetails)} UTC`" />
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="chainId">
        <Paragraph class="text-left text-[25px] text-blue-dark font-jost-regular leading-[36px]"
          text="There is no data for this chain" />
        <HeadingComponent :text="chainId"
          class="text-left text-[33px] font-jost-regular text-blue-light break-all leading-[47px]" />
      </div>
    </div>
  </template>
</template>

<script>
import "vue-json-pretty/lib/styles.css";
import Paragraph from "@/components/web/ParagraphComponent";
import { mapGetters } from 'vuex';
import api from '@/helpers/api';
import string from '@/helpers/string';
import HeadingComponent from '@/components/web/HeadingComponent';
import CopyIcon from '@/components/svg/CopyIcon';
import Loader from '@/components/common/Loader.vue';

export default {
  name: "ChainComponent",
  components: {
    // CopyIcon,
    Paragraph,
    HeadingComponent,
    Loader,
  },
  data: () => {
    return {
      copied: '',
      isLoading: false,
      chainDetails: {},
      lastPath: null,
    }
  },
  computed: {
    chainId() {
      return this.$route.params.chainNumber;
    },
  },
  created() {
    this.getChainDetails();
    this.lastPath = this.$router.options.history.state.back;
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    getChainDetails() {
      this.isLoading = true;

      return api.getChainByNumber(this.chainId)
        .then((res) => {
          this.chainDetails = res.data.result;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        })
    },
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    setCopied(hash) {
      this.copied = hash;
    },
  }
}
</script>
<style scoped>
.icon {
  display: inline-block;
  vertical-align: middle;
}
.icon--plus > path {
  fill: #3D94C3;
  stroke: #3D94C3;
  stroke-width: 0.01;
  stroke-linejoin: round;
}
header, .row {
  display: flex;  /* aligns all child elements (flex items) in a row */
}

.col {
  flex: 1;        /* distributes space on the line equally among items */
  width: calc(100% / 3);
}
.popover__content {
  right: unset;
  left: 10px;
  bottom: 0;
}
.result-row {
  min-height: 54px;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #666666;
}
</style>
